// removed by extract-text-webpack-plugin
module.exports = {"YoutubePlayer":"YoutubePlayer","YoutubePlayer__btn-mute":"YoutubePlayer__btn-mute"};


//////////////////
// WEBPACK FOOTER
// ./src/components/youtube-player/styles.css
// module id = 794
// module chunks = 0 1